import { text } from '@onbeam/business-styled-system/patterns';

export const footerLinkStyles = text({
  color: 'mono.tertiary',
  transition: 'colors',
  cursor: 'pointer',
  _hoverFocus: {
    color: 'mono.primaryBg',
  },
});
